import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { MantineReactTable } from "mantine-react-table";
import "./location1.css";
import Swal from "sweetalert2";
import {
  getOrgId,
  EditDepartment,
  HEADERS,
  AddDepartment,
  DeleteDepartment,
  GetDepartment,
} from "../../api";
import axios from "axios";

export default function Department1() {
  const [data, setData] = useState([]);
  const [departments, setDepartment] = useState([]);
  const [pageSize, setPageSize] = useState(5);
  const [page, setPage] = useState(0);

  const selectElement = document.createElement("select");
  selectElement.id = "SubDeptFor";
  selectElement.className = "swal2-input";

  departments.forEach((optionText) => {
    const option = document.createElement("option");
    option.text = option.value = optionText;
    selectElement.add(option);
  });

  const AddDepartmentBtn = async () => {
    const { value: formValues, isConfirmed } = await Swal.fire({
      title: "Add Department",
      showCancelButton: true,
      confirmButtonText: "Add",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      customClass: {
        confirmButton: "swal-custom-confirm-btn",
        cancelButton: "swal-custom-cancel-btn",
      },

      html: `
      <div class="p-2 d-flex flex-column gap-2">
        <div class="d-flex flex-column">
          <small class="text-start">Department Name</small>
          <input id="DepartmentName" class="form-control  mt-1" placeholder="Enter DepartmentName" autofocus>
        </div>
        <div class="d-flex flex-column">
          <small class="text-start">Department Code</small>
          <input id="DepartmentCode" class="form-control  mt-1" placeholder="Enter DepartmentCode" autofocus maxlength="2">
        </div>
        <div class="d-flex flex-column">
          <small class="text-start">Sub Department</small>
          <select id="SubDeptFor" class="form-select mt-1" autofocus>
            <option value="" disabled selected>Sub-Department For</option>
            ${departments
              .map(
                (department) =>
                  `<option value="${department.dept_id}">${department.dept_name}</option>`
              )
              .join("")}
          </select>        
        </div>
      </div>

        `,

      preConfirm: async () => {
        const DepartmentName =
          Swal.getPopup().querySelector("#DepartmentName").value;
        const DepartmentCode =
          Swal.getPopup().querySelector("#DepartmentCode").value;
        const SubDeptFor = Swal.getPopup().querySelector("#SubDeptFor").value;
        const twoDigitsRegex = /^[a-zA-Z0-9]{2}$/;
        if (!twoDigitsRegex.test(DepartmentCode)) {
          Swal.showValidationMessage(
            "Please enter exactly two digits for DepartmentCode"
          );
          return {
            success: false,
            message: "Please enter exactly two digits for DepartmentCode",
          };
        }
        if (!DepartmentName || !DepartmentCode) {
          Swal.showValidationMessage("Please fill in all the fields");
          return { success: false, message: "Please fill in all the fields" };
        }
        const OrgID = getOrgId();
        const requestBody = {
          organization_id: OrgID,
          dept_code: DepartmentCode,
          dept_name: DepartmentName,
          sub_dept_for: SubDeptFor,
        };

        // $&
        try {
          const response = await fetch(AddDepartment, {
            method: "POST",
            headers: HEADERS,
            body: JSON.stringify(requestBody),
          });

          // $&

          if (response.ok) {
            const result = await response.json();
            setData([...data, result]);
            // $&
            // window.location.reload();
            fetchData();

            return {
              DepartmentCode,
              DepartmentName,
              success: result.response_code === "0000",
              message: result.response_description,
            };
          } else {
            console.error("Failed to add department");
            return { success: false, message: "Failed to add Department" };
          }
        } catch (error) {
          console.error("Error during department creation:", error);
          return {
            success: false,
            message: "Error during department creation",
          };
        }
      },
    });

    if (isConfirmed) {
      const { success, message } = formValues;
      Swal.fire(
        success ? "Added!" : "Failed!",
        success
          ? "Department has been added."
          : `Failed to add the Department. ${message}`,
        success ? "success" : "error"
      );
    }
  };

  const fetchData = async () => {
    const OrgID = getOrgId();
    try {
      const requestData = { org_id: OrgID };
      const response = await axios.post(GetDepartment, requestData, {
        headers: HEADERS,
      });

      if (response.data.response_code === "0000") {
        // $&
        setDepartment(response.data.data);
      } else {
        console.error("Error fetching users. Please try again later.");
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const EditDepartmentBtn = async (id) => {
    try {
      const existingDepartment = departments.find(
        (department) => department.dept_id === id
      );
      if (!existingDepartment) {
        Swal.fire("Error", "Department not found!", "error");
        return;
      }

      const lastTwoDigits = existingDepartment.dept_code.slice(-2);
      const existingSubDepartment = departments.find(
        (department) => department.dept_id === existingDepartment.sub_dept_for
      );

      const { value: formValues, isConfirmed } = await Swal.fire({
        title: "Edit Department",
        showCancelButton: true,
        confirmButtonText: "Update",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
        html: `
          <div class="p-2 d-flex flex-column gap-2">
            <div class="d-flex flex-column">
              <small class="text-start">Department Code</small>
              <input id="DepartmentCode" class="form-control mt-1" value="${lastTwoDigits}"  maxlength="2">
            </div>
            <div class="d-flex flex-column">
              <small class="text-start">Department Name</small>
              <input id="DepartmentName" class="form-control mt-1" value="${
                existingDepartment.dept_name
              }">
            </div>
            <div class="d-flex flex-column">
              <small class="text-start">Sub Department</small>
              <select id="SubDeptFor" class="form-select mt-1">
                <option value="" ${
                  !existingSubDepartment ? "selected" : ""
                }>No Sub-Department</option>
                ${departments
                  .map(
                    (department) => `
                  <option value="${department.dept_id}" ${
                      existingDepartment.sub_dept_for === department.dept_id
                        ? "selected"
                        : ""
                    }>
                    ${department.dept_name}
                  </option>
                `
                  )
                  .join("")}
              </select>
            </div>
          </div>
        `,
        preConfirm: async () => {
          const EditDepartmentName =
            Swal.getPopup().querySelector("#DepartmentName").value;
          const LastTwoDigits =
            Swal.getPopup().querySelector("#DepartmentCode").value;
          const SubDeptFor = Swal.getPopup().querySelector("#SubDeptFor").value;

          if (!EditDepartmentName || !LastTwoDigits) {
            Swal.showValidationMessage("Please fill in all the fields");
            return null;
          }

          const OrgID = getOrgId();
          const newDeptCode =
            existingDepartment.dept_code.slice(0, -2) + LastTwoDigits;
          const requestBody = {
            organization_id: OrgID,
            dept_id: id,
            dept_code: LastTwoDigits,
            dept_name: EditDepartmentName,
            sub_dept_for: SubDeptFor,
          };

          try {
            const response = await axios.post(EditDepartment, requestBody, {
              headers: HEADERS,
            });
            if (response.data.response_code === "0000") {
              const updatedDepartments = departments.map((department) =>
                department.dept_id === id
                  ? {
                      ...department,
                      dept_code: newDeptCode,
                      dept_name: EditDepartmentName,
                      sub_dept_for: SubDeptFor || null,
                    }
                  : department
              );
              fetchData();
              setDepartment(updatedDepartments);
              return {
                success: true,
                message: "Department updated successfully",
              };
            } else {
              Swal.fire(
                "Error",
                response.data.response_description ||
                  "Failed to update the department.",
                "error"
              );
              return {
                success: false,
                message: response.data.response_description,
              };
            }
          } catch (error) {
            Swal.fire(
              "Error",
              error.message ||
                "An unexpected error occurred during the update.",
              "error"
            );
            return { success: false, message: error.message };
          }
        },
      });
      if (isConfirmed && formValues) {
        const { success, message } = formValues;
        Swal.fire(
          success ? "Updated!" : "Failed!",
          message ||
            (success
              ? "Department updated successfully."
              : "Failed to update the Department."),
          success ? "success" : "error"
        );
      }
    } catch (error) {
      Swal.fire(
        "Error",
        "An error occurred during department editing.",
        "error"
      );
      console.error("Error:", error);
    }
  };

  const handleDelete = async (depID) => {
    try {
      const confirmDelete = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this department!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      });

      if (confirmDelete.isConfirmed) {
        const response = await axios.post(
          DeleteDepartment,
          { dept_id: depID },
          { headers: HEADERS }
        );

        if (response.data.response_code === "0000") {
          Swal.fire("Deleted!", "Department has been deleted.", "success");
          fetchData();
        } else {
          Swal.fire(
            "Failed!",
            "Failed to delete the Department. Please try again later.",
            "error"
          );
          console.error("Error deleting Department. Please try again later.");
        }
      }
    } catch (error) {
      console.error("An error occurred while deleting Department:", error);
    }
  };

  const tableData = departments.map((department) => ({
    dept_code: department.dept_code,
    sub_dept_name: department.sub_dept_name,
    dept_name: department.dept_name,
    has_head: String(Boolean(department.has_head)),
    has_officiated_person: String(Boolean(department.has_officiated_person)),

    edit: (
      <Link onClick={() => EditDepartmentBtn(department.dept_id)}>
        <FontAwesomeIcon icon={faEdit} style={{ cursor: "pointer" }} />
      </Link>
    ),
    delete: (
      <FontAwesomeIcon
        icon={faTrash}
        onClick={() => handleDelete(department.dept_id)}
        style={{ cursor: "pointer" }}
      />
    ),
  }));

  const tableColumns = [
    {
      accessorKey: "dept_code",
      header: "Code",
    },

    {
      accessorKey: "dept_name",
      header: "Department",
    },

    {
      accessorKey: "has_head",
      header: "Has Head",
    },
    {
      accessorKey: "sub_dept_name",
      header: "Sub Department For",
    },
    {
      accessorKey: "has_officiated_person",
      header: "Has Officated Person",
    },
    {
      accessorKey: "edit",
      header: "Edit",
    },
    {
      accessorKey: "delete",
      header: "Delete",
    },
  ];
  const paginatedData = tableData.slice(page * pageSize, (page + 1) * pageSize);
  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, tableData.length);
  const totalRows = tableData.length;

  const handlePageChange = (newPage) => setPage(newPage);
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
  };

  return (
    <div className="">
      <div>
        <span className="breadcrumb d-flex gap-2">
          <Link
            className="previou-link text-decoration-none"
            to="/user-setting-dashboard"
          >
            Setting
          </Link>
          <span>/</span>
          <span className="current-link text-decoration-none">Department</span>
        </span>
      </div>
      <div className="headerSection">
        <span className="title">Department</span>
        <button className="button add-button" onClick={AddDepartmentBtn}>
          Add Department
        </button>
      </div>
      <div className="tab mt-3">
        <MantineReactTable
          columns={tableColumns}
          data={paginatedData}
          enablePagination={false}
          enableColumnFilters={true}
          enableSorting={true}
          enableColumnOrdering={true}
          enableGlobalFilter={true}
          enableRowSelection={false}
          enableFullScreenToggle={false}
          mantineTableBodyCellProps={{
            style: {
              backgroundColor: "#C8E3EC60",
              color: "#505050",
              border: "0.5px solid #fff",
              padding: "10px",
            },
          }}
          mantineTableHeadCellProps={{
            style: {
              backgroundColor: "#2d7d9f",
              fontSize: "14px",
              fontWeight: 500,
              color: "#fff",
              border: "1px solid #fff",
            },
          }}
          mantineTableBodyRowProps={(row) => ({
            style: {
              backgroundColor: row.index % 2 === 0 ? "#f9f9f9" : "#fff",
            },
          })}
        />
        <div className="pagination-container border p-2 d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontSize: "14px" }}>Items per page:</span>
            <select
              className="form-select"
              style={{ width: "110px" }}
              value={pageSize}
              onChange={(e) => handlePageSizeChange(parseInt(e.target.value))}
            >
              <option value={5}>5 rows</option>
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
              <option value={100}>100 rows</option>
            </select>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <span style={{ fontSize: "14px" }}>
              {totalRows === 0
                ? "Showing 0 to 0 of 0 entries"
                : `Showing ${startRow} - ${endRow} of ${totalRows} entries`}
            </span>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-3">
            <button
              className="previous-button"
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 0}
            >
              Previous
            </button>
            <button
              className="add-button text-center justify-content-center"
              style={{ width: "100px" }}
              onClick={() => handlePageChange(page + 1)}
              disabled={(page + 1) * pageSize >= tableData.length}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
